import { app, Component } from 'apprun';
import { captcha } from './captcha';
import { __, lang } from './Txlat';
import { getPropertyLinkWithoutAddress, getProvinceInfo } from './utility';
import { getPropertyByID } from './model/property';
import { agent } from './api';
import InqueryTitle from './agent-inquiry-title';
export const getAgentByIDAndPersonID = agent.getAgentByIDAndPersonID;

declare const jQuery;
export default class InquiryForm extends Component {
  isPopup = true;

  constructor(state?) {
    super();
    this.isPopup = state?.isPopup;
  }

  state = {
    gcaptcha: captcha.get()
  };

  view = (state) => {
    return (
      <div class="property-form-wrap">
        {state.form_type === 'Property' && state.property?.rlp === 'true' || state.form_type === 'AgentProfile' ?
          <div class="agent-details">
            {state.inqueryTitle}
          </div> : <div></div>
        }

        <div class="property-form clearfix">
          <div class="form_messages"></div>

          <form method="post" class={`inqForm${state.formName ?? ''}`} id={`inqForm${state.formName ?? ''}`}>
            {state.property?.rlp === 'false' ?
              <div>
                <div class="form-group">
                  {__('Are you under a signed contract with an agent?')}
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name={`haveAgent${state.formName ?? ''}`} id={`haveAgent1${state.formName ?? ''}`} value={__('Yes')} required $onchange={['checkHaveAgent', state]} />
                  <label class="form-check-label" for={`haveAgent1${state.formName ?? ''}`} style="padding-bottom: 0;">
                    {__('Yes')}
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name={`haveAgent${state.formName ?? ''}`} id={`haveAgent2${state.formName ?? ''}`} value={__('No')} required $onchange={['checkHaveAgent', state]} />
                  <label class="form-check-label" for={`haveAgent2${state.formName ?? ''}`} style="padding-bottom: 0;">
                    {__('No')}
                  </label>
                </div>
                <div id="haveAgentError" class="invalid-feedback">
                  {__('Please make a selection.')}
                </div>
              </div> : <div></div>}

            <div style='display:block' id={`input_form${state.formName ?? ''}`}>
              {state.property?.rlp === 'true' && state.agent2_name ?
                <div class="form-group">
                  <select id={`agents${state.formName ?? ''}`} name={`agents${state.formName ?? ''}`} data-size="3" class="selectpicker form-control"
                    title={__('Agents')} data-live-search="false" data-selected-text-format="count > 1"
                    data-actions-box="true" multiple data-select-all-text={__('Select All')}
                    data-deselect-all-text={__('Deselect All')}
                    data-count-selected-text={'{0} ' + __('Agents')} required
                    $onchange={['checkAgents', state]}>
                    <option value={state.email}>{state.agent1_name}</option>
                    <option value={state.email2}>{state.agent2_name}</option>
                  </select>
                  <div id="agentsError" class="invalid-feedback">
                    {__('Please make a selection.')}
                  </div>
                </div> : <div></div>
              }

              <div class="form-group">
                <input class="form-control" name={`name${state.formName ?? ''}`} value="" type="text" placeholder={__('Your Name')} spellcheck="false" required data-msgfield={__('Name') + ': '} pattern="^\s*\S(?:.*\S)?\s*$" />
                <div class="invalid-feedback">
                  {__('Please provide your name.')}
                </div>
              </div>

              <div class="form-group">
                <input class="form-control" name={`email${state.formName ?? ''}`} value="" type="email" placeholder={__('Your Email')} required data-msgfield={__('Email Address') + ': '} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
                <div class="invalid-feedback">
                  {__('Please provide a valid email address.')}
                </div>
              </div>

              <div class="form-group">
                <input class="form-control" id={`phone${state.formName ?? ''}`} name={`phone${state.formName ?? ''}`} value="" type="tel" placeholder={__('Phone') + ': 666-888-8888'} required pattern='^\+?([0-9]{3})\)?[ \-]?([0-9]{3})[ \-]?([0-9]{4})$' data-msgfield={__('Phone') + ': '} />

                <div class="invalid-feedback">
                  {__('Please provide a valid phone number.')}
                </div>
              </div>

              {state.property?.rlp === 'true' ?
                <div class="form-group form-group-textarea">
                  <textarea class="form-control" name={`message${state.formName ?? ''}`} rows="4" placeholder="Message" spellcheck="false" required data-msgfield={__('Message') + ': \r\n'}>
                    {__('Hi')} {state.name}, &#13;{__('I saw your profile on the Royal LePage Commercial website, and I have a few questions. Please contact me.')}
                  </textarea>
                  <div class="invalid-feedback ">
                    {__('Pleaes provide some detail information.')}
                  </div>
                </div> : <div class="form-group form-group-textarea">
                  <textarea class="form-control" name={`message${state.formName ?? ''}`} rows="4" placeholder="Message" spellcheck="false" required data-msgfield={__('Message') + ': \r\n'}>
                  </textarea>
                  <div class="invalid-feedback ">
                    {__('Pleaes provide some detail information.')}
                  </div>
                </div>}

              <div class="form-group">
                <label class="control control--checkbox m-0 hz-terms-of-use">
                  <input class="form-check-input" type="checkbox" value="" id={`invalidCheck${state.formName ?? ''}`} required />
                  {__('By submitting this form, I agree to the')}
                  &nbsp;<a target="_blank" href={__('https://www.royallepage.ca/en/realestate/legal-notice/')}>{__('Terms of Use')}</a>
                  <div class="invalid-feedback">
                    {__('You must agree before submitting.')}
                  </div>
                  <span class="control__indicator" style='border: 1px solid red;' ></span>
                </label>
              </div>

              <a class="btn btn-search btn-secondary btn-full-width" href='' style='color:white;' $onclick='onsubmit'>
                {__('Submit')}<span class="btn-loader houzez-loader-js"></span>
              </a>

              <div class="form-group">
                <br />
                <label class="control control--checkbox m-0 hz-terms-of-use">
                  {__('Royal LePage Commercial does not share your contact information outside of our organization. Read our')}
                  &nbsp;<a target="_blank" href={__('https://www.royallepage.ca/en/realestate/privacy-policy/')}>{__('Privacy Policy.')}</a>
                </label>
              </div>

              <div id={`success${state.formName ?? ''}`} class="valid-feedback" style='display:none'>
                {__('Your email has been sent successfully!')}
              </div>
              <div id={`failmsg${state.formName ?? ''}`} class="invalid-feedback" style='display:none'>
                {__('Error occured while submitting your email!')}
              </div>

              <div id={`failemailmsg${state.formName ?? ''}`} class="invalid-feedback" style='display:none'>
                {__('Hey rlp Agent, please contact the listing agent.')}
              </div>

            </div>

          </form>
          <div style='display:none' id="message">
            <p></p>
            <h5>{__('Please contact your agent directly about this listing.')}</h5>
            <p></p>

            {/* <div style="text-align: center; padding-top: 200px; padding-bottom: 40px;">
          <button type="button" class="btn btn-search btn-secondary" style="color: white; " data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">{__('Close')}</span>
          </button>
        </div> */}

          </div>

        </div >
      </div >);
  };

  update = {
    '/openInqueryModal': async (state, new_state) => {

      if (new_state.property) {
        const property = await getPropertyByID(new_state.property.id);

        const agent1 = { id: property.agent_person_id, alaia_id: property.agent_id, photo_path: property.agent_photo, name: property.agent_name, address: property.agent_address, city: property.agent_city, province: property.agent_province, postal_code: property.agent_postal_code, phone: property.agent_phone, email: property.agent_email, officeName: property.agent_office_name, title: property.agent_title, title_FR: property.agent_title_FR, isCommercailAgent: false };
        const agent2 = { id: property.agent2_person_id, alaia_id: property.agent2_id, photo_path: property.agent2_photo, name: property.agent2_name, address: property.agent2_address, city: property.agent2_city, province: property.agent2_province, postal_code: property.agent2_postal_code, phone: property.agent2_phone, email: property.agent2_email, officeName: property.agent_office_name, title: property.agent2_title, title_FR: property.agent_title_FR, isCommercailAgent: false };
        const inqueryTitle = <InqueryTitle agent1={agent1} agent2={agent2} />;
        const emailSubject = `${__('Inquiry regarding - ')}MLS ${property.mls_id} - ${property.address}`;

        new_state = { inqueryTitle: inqueryTitle, email: agent1.email, email2: agent2.email, agent1_name: agent1.name, agent2_name: agent2.name, inquiryType: 'PropertyInquiry', sub: emailSubject, property, agent1, agent2, form_type: 'Property' };

        if ((new_state.agent1?.id || new_state.agent1?.alaia_id) && new_state.agent1?.name) {
          const pid = await getAgentByIDAndPersonID(new_state.agent1.alaia_id ?? -1, new_state.agent1.id ?? -1);
          if (pid.length > 0) {
            new_state.agent1.isCommercailAgent = true;
            new_state.agent1.id = pid[0].id;
            new_state.agent1.alaia_id = pid[0].alaia_id;
          } else {
            new_state.agent1.isCommercailAgent = false;
          }
        }

        if ((new_state.agent2?.id || new_state.agent2?.alaia_id) && new_state.agent2?.name) {
          const pid2 = await getAgentByIDAndPersonID(new_state.agent2.alaia_id ?? -1, new_state.agent2.id ?? -1);
          if (pid2.length > 0) {
            new_state.agent2.isCommercailAgent = true;
            new_state.agent2.id = pid2[0].id;
            new_state.agent2.alaia_id = pid2[0].alaia_id;
          } else {
            new_state.agent2.isCommercailAgent = false;
          }
        }

        if (new_state.agent1 || new_state.agent2) {
          const inqueryTitle = <InqueryTitle agent1={new_state.agent1} agent2={new_state.agent2} />;
          new_state.inqueryTitle = inqueryTitle;
        }

      }

      const haveAgentElements = document.querySelectorAll('input[name="haveAgent"]');

      // Loop through each radio button and set its checked property to false
      for (let i = 0; i < haveAgentElements.length; i++) {
        (haveAgentElements[i] as HTMLInputElement).checked = false;
      }

      jQuery('#mobile-property-form').modal('show');

      if (this.isPopup) { return { ...state, ...new_state }; }
    },

    '/setInqueryComponentState': async (state, new_state) => {
      return { ...state, ...new_state };
    },

    onsubmit: async (state, e) => {
      //const form = e.target.parentElement as HTMLFormElement;
      const form = document.getElementById(`inqForm${state.formName ?? ''}`) as HTMLFormElement;

      document.getElementById(`success${state.formName ?? ''}`).style.display = 'none';
      document.getElementById(`failmsg${state.formName ?? ''}`).style.display = 'none';

      document.getElementById(`failemailmsg${state.formName ?? ''}`).style.display = 'none';

      if (state.property?.rlp === 'false') {
        const haveAgentElements = document.querySelectorAll(`input[name="haveAgent${state.formName ?? ''}"]`);
        const haveAgentMsg = document.querySelector(`#haveAgentError${state.formName ?? ''}`);

        let checkedHaveAgent = false;
        for (let i = 0; i < haveAgentElements.length; i++) {
          if ((haveAgentElements[i] as HTMLInputElement).checked) {
            checkedHaveAgent = true;
            break;
          }
        }

        if (checkedHaveAgent) {
          haveAgentMsg.classList.remove('d-block');
        } else {
          haveAgentMsg.classList.add('d-block');
        }
      }

      const selectAgentsElements = document.querySelectorAll(`#agents${state.formName ?? ''}`);
      const errorAgentsMsg = document.querySelectorAll(`#agentsError${state.formName ?? ''}`);
      for (let i = 0; i < selectAgentsElements.length; i++) {
        if ((selectAgentsElements[i] as HTMLSelectElement).matches(':invalid')) {
          (errorAgentsMsg[i] as HTMLInputElement).classList.add('d-block');
        } else {
          (errorAgentsMsg[i] as HTMLInputElement).classList.remove('d-block');
        }
      }

      const email = (document.querySelector(`input[name="email${state.formName ?? ''}"]`) as HTMLInputElement).value;

      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        form.classList.add('was-validated');
      } else {

        if (state.form_type === 'Property' && state.property.rlp === 'false'
          && (email.toLocaleLowerCase().includes('royallepage.ca')
            || email.toLocaleLowerCase().includes('johnstonanddaniel.com')
            || email.toLocaleLowerCase().includes('royallepagecommercial.com'))) {
          document.getElementById(`failemailmsg${state.formName ?? ''}`).style.display = 'block';
          e.preventDefault();
          e.stopPropagation();
          form.classList.remove('was-validated');
          return;
        }

        state.inquiryType = (state.inquiryType) ? state.inquiryType : 'GeneralInquiry';
        state.email = (state.email) ? state.email : 'help@royallepagecommercial.com';
        const subject = (state.inquiryType === 'PropertyInquiry') ? state.sub : __('Inquiry posted at rlpCommercial.com');

        let emails = '';

        let names = '';

        if (state.property?.rlp === 'true' && state.agent2_name) {
          const selectElement = document.getElementById(`agents${state.formName ?? ''}`) as HTMLSelectElement;
          const checked = Array.from(selectElement.selectedOptions).map(option => option.value);
          for (let i = 0; i < checked.length; i++) {
            if (emails) {
              emails += ';' + checked[i];
            } else {
              emails = checked[i];
            }
          }

          const checkedName = Array.from(selectElement.selectedOptions).map(option => option.textContent);
          for (let i = 0; i < checkedName.length; i++) {
            if (names) {
              names += ';' + checkedName[i];
            } else {
              names = checkedName[i];
            }
          }

        } else {
          emails = state.email;
          names = state.agent1_name;
        }

        const name = (document.querySelector(`input[name="name${state.formName ?? ''}"]`) as HTMLInputElement).value;

        const phoneBox = document.querySelector(`input[name="phone${state.formName ?? ''}"]`) as HTMLInputElement;

        let phone = '';
        if (phoneBox) { phone = phoneBox.value; }

        const text = (document.querySelector(`textarea[name="message${state.formName ?? ''}"]`) as HTMLInputElement).value;

        let formUrl = '';

        if (state.property) {
          formUrl = window.location.protocol + '//' + window.location.hostname + getPropertyLinkWithoutAddress(state.property, lang.get());
        }

        let listing_content, price;

        try {
          let result;

          if (state.form_type === 'Property' && state.property.rlp === 'false') {
            if (state.property.status === 'lease') {
              price = state.property.lease_price ? state.property.lease_price : '';
              listing_content = `MLS: ${state.property.mls_id}\nprice: ${price}\ntransaction_type: ${state.property.status}\nsearch_category: ${state.property.property_type ? state.property.property_type : ''}\nlisting_type: Commercial`;
            } else {
              price = state.property.sale_price ? state.property.sale_price : '';
              listing_content = `MLS: ${state.property.mls_id}\nprice: ${price}\ntransaction_type: ${state.property.status}\nsearch_category: ${state.property.property_type ? state.property.property_type : ''}\nlisting_type: Commercial`;
            }
            const data = {
              name,
              email,
              phone,
              fsa: state.property.postal_code.substring(0, 3),
              text,
              lang: lang.get(),
              geolocation_address: `${state.property.address}, ${state.property.city}, ${state.property.province}, ${state.property.postal_code}`,
              source_email: 'leads@royallepagecommercial.com',
              lead_source: 'COM_DDF',
              listing_content,
              url: formUrl,
              poi_city: state.property.city,
              poi_state: getProvinceInfo(state.property.province)[0],
              poi_zip: state.property.postal_code,
              province: getProvinceInfo(state.property.province)[1],
              avg_price: price,
              lat: state.property.latitude,
              lng: state.property.longitude,

            };

            result = await captcha.leadAssign(await state.gcaptcha, data);

          } else if (state.form_type === 'Property' && state.property.rlp === 'true') {

            if (email.toLocaleLowerCase().includes('royallepage.ca')
              || email.toLocaleLowerCase().includes('johnstonanddaniel.com')
              || email.toLocaleLowerCase().includes('royallepagecommercial.com')) {
              result = await captcha.email(await state.gcaptcha, form, state.inquiryType, subject, emails);
            } else {
              if (state.property.status === 'lease') {
                price = state.property.lease_price ? state.property.lease_price : '';
                listing_content = `MLS: ${state.property.mls_id}\nprice: ${price}\ntransaction_type: ${state.property.status}\nsearch_category: ${state.property.property_type ? state.property.property_type : ''}\nlisting_type: Commercial`;
              } else {
                price = state.property.sale_price ? state.property.sale_price : '';
                listing_content = `MLS: ${state.property.mls_id}\nprice: ${price}\ntransaction_type: ${state.property.status}\nsearch_category: ${state.property.property_type ? state.property.property_type : ''}\nlisting_type: Commercial`;
              }

              const data = {
                name,
                email,
                phone,
                fsa: state.property.postal_code.substring(0, 3),
                text,
                lang: lang.get(),
                geolocation_address: `${state.property.address}, ${state.property.city}, ${state.property.province}, ${state.property.postal_code}`,
                source_email: 'leads@royallepagecommercial.com',
                lead_source: 'COM_COURTESY',
                listing_content,
                url: formUrl,
                poi_city: state.property.city,
                poi_state: getProvinceInfo(state.property.province)[0],
                poi_zip: state.property.postal_code,
                province: getProvinceInfo(state.property.province)[1],
                avg_price: price,
                lat: state.property.latitude,
                lng: state.property.longitude,
                identified_agent: state.property.agent_id ? state.property.agent_id : state.email,
              };

              result = await captcha.leadAssign(await state.gcaptcha, data);
            }
          } else if (state.form_type === 'AgentProfile') {

            if (email.toLocaleLowerCase().includes('royallepage.ca')
              || email.toLocaleLowerCase().includes('johnstonanddaniel.com')
              || email.toLocaleLowerCase().includes('royallepagecommercial.com')) {
              result = await captcha.email(await state.gcaptcha, form, state.inquiryType, subject, emails);
            } else {
              const data = {
                name,
                email,
                phone,
                fsa: '',
                text,
                lang: lang.get(),
                geolocation_address: '',
                source_email: 'leads@royallepagecommercial.com',
                lead_source: 'COM_COURTESY_PROFILE',
                listing_content: '',
                url: formUrl,
                poi_city: '',
                poi_state: '',
                poi_zip: '',
                province: '',
                avg_price: '',
                lat: '',
                lng: '',
                identified_agent: state.agent1.alaia_id ? state.agent1.alaia_id : state.email,
              };

              result = await captcha.leadAssign(await state.gcaptcha, data);
            }
          } else {
            result = await captcha.email(await state.gcaptcha, form, state.inquiryType, subject, emails);
          }

          if (result && (result !== '')) {
            //alert(result);

            const formElements = document.querySelectorAll(`.inqForm${state.formName ?? ''}`);
            for (let i = 0; i < formElements.length; i++) {
              jQuery(`#agents${state.formName ?? ''}`).val('').selectpicker('refresh');
              (formElements[i] as HTMLFormElement).reset();  // Reset all form data
              document.getElementById(`success${state.formName ?? ''}`).style.display = 'block';
              formElements[i].classList.remove('was-validated');
            }
            jQuery('#mobile-property-form').modal('hide');
          }
        } catch (error) {
          //const err = await error.json();
          //alert(err.body);
          document.getElementById(`failmsg${state.formName ?? ''}`).style.display = 'block';
        }
      }
    },

    checkAgents: (state) => {
      document.getElementById(`success${state.formName ?? ''}`).style.display = 'none';
      document.getElementById(`failmsg${state.formName ?? ''}`).style.display = 'none';

      document.getElementById(`failemailmsg${state.formName ?? ''}`).style.display = 'none';

      const selectAgentsElements = document.querySelectorAll(`#agents${state.formName ?? ''}`);
      const errorAgentsMsg = document.querySelectorAll(`#agentsError${state.formName ?? ''}`);
      for (let i = 0; i < selectAgentsElements.length; i++) {
        if ((selectAgentsElements[i] as HTMLSelectElement).matches(':invalid')) {
          (errorAgentsMsg[i] as HTMLInputElement).classList.add('d-block');
        } else {
          (errorAgentsMsg[i] as HTMLInputElement).classList.remove('d-block');
        }
      }
    },

    checkHaveAgent: (state) => {
      document.getElementById(`success${state.formName ?? ''}`).style.display = 'none';
      document.getElementById(`failmsg${state.formName ?? ''}`).style.display = 'none';

      document.getElementById(`failemailmsg${state.formName ?? ''}`).style.display = 'none';

      const haveAgentElements = document.querySelectorAll(`input[name="haveAgent${state.formName ?? ''}"]`);
      const haveAgentMsg = document.querySelector(`#haveAgentError${state.formName ?? ''}`);

      let checkedHaveAgent = false;
      for (let i = 0; i < haveAgentElements.length; i++) {
        if ((haveAgentElements[i] as HTMLInputElement).checked) {
          checkedHaveAgent = true;
          break;
        }
      }

      if (checkedHaveAgent) {
        haveAgentMsg.classList.remove('d-block');
      } else {
        haveAgentMsg.classList.add('d-block');
      }
      const haveAgent = (document.querySelector(`input[name="haveAgent${state.formName ?? ''}"]:checked`) as HTMLInputElement).value;

      const input_form = document.getElementById(`input_form${state.formName ?? ''}`);
      const message = document.getElementById(`message${state.formName ?? ''}`);

      if (haveAgent === __('Yes')) {
        input_form.style.display = 'none';
        message.style.display = 'block';
      } else {
        input_form.style.display = 'block';
        message.style.display = 'none';
      }

    },

  };

  rendered = () => {
    jQuery('.selectpicker').selectpicker('refresh');
  };
}
